import {Box, Center, Paper, Text, ThemeIcon, Title} from "@mantine/core";
import {ReactNode} from "react";

export function DenyPopover({
    icon,
    title,
    description,
    action,
}: {
    icon: ReactNode;
    title: string;
    description: string;
    action?: ReactNode;
}) {
    return (
        <Box
            pos={"absolute"}
            style={{
                zIndex: 10000,
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                backdropFilter: "blur(5px)",
                width: "100vw",
                height: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <Paper
                withBorder
                shadow="md"
                px={"xl"}
                py={60}
                radius="md"
                style={{maxWidth: "500px"}}
            >
                <Title order={3} ta="center" mt="md" mb="xs">
                    {title}
                </Title>
                <Text c="dimmed" size="sm" ta="center">
                    {description}
                </Text>
                {action && <Center mt="xl">{action}</Center>}
            </Paper>
        </Box>
    );
}
